import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99729 13.2807L5.65063 8.93404C5.13729 8.4207 5.13729 7.5807 5.65063 7.06737L9.99729 2.7207",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowRightIcon;
